export default __webpack_public_path__ + "static/media/book3.3c979c37.jpg";